<template>
    <div :class="{'p-6': $mq != 'mobile', 'p-4': $mq == 'mobile'}">
        <p class="uppercase text-lg font-medium text-brand text-center my-4 sm:my-6" v-if="$mq == 'mobile'">Enter your Personal Details</p>

        <div :class="{'p-6 border': $mq != 'mobile'}">
            <div class="my-6 relative">
                <p class="uppercase text-lg font-light text-center my-6" v-if="$mq != 'mobile'">Enter your Personal Details</p>
                <div class="text-center sm:text-right sm:absolute sm:right-0 sm:top-0 text-sm font-light text-grey"><span class="text-brand">*</span> Required fields</div>
            </div>

            <form class="py-4 mt-4 text-center sm:text-left" @submit.prevent="validateAndNext">
                <div class="flex flex-wrap">
                    <div class="w-full sm:w-1/2 sm:pr-8">
                        <label class="font-medium"><span class="text-brand">*</span> First Name</label>
                        <input type="text" 
                            class="w-full border py-2 px-3 mt-2 rounded" 
                            v-model="form.user.first_name"
                            v-validate="'required'"
                            name="first_name"
                            tabindex="1"
                            :class="{'border-red':errors.has('first_name')}">
                        <div v-show="errors.has('first_name')" class="text-red text-sm mt-2">
                            {{ errors.first('first_name') }}
                        </div>
                    </div>
                    <div class="w-full sm:w-1/2 mt-4 sm:mt-0">
                        <label class="font-medium"><span class="text-brand">*</span> Last Name</label>
                        <input type="text" 
                            class="w-full border py-2 px-3 mt-2 rounded" 
                            v-model="form.user.last_name"
                            v-validate="'required'"
                            name="last_name"
                            tabindex="2"
                            :class="{'border-red':errors.has('last_name')}">
                        <div v-show="errors.has('last_name')" class="text-red text-sm mt-2">
                            {{ errors.first('last_name') }}
                        </div>
                    </div>
                </div>
                <div class="flex flex-wrap sm:mt-8">
                    <div class="w-full sm:w-1/2 sm:pr-8 mt-4 sm:mt-0">
                        <label class="font-medium"><span class="text-brand">*</span> Mobile</label>
                        <input type="text" 
                            class="w-full border py-2 px-3 mt-2 rounded" 
                            v-model="form.user.mobile_number"
                            v-validate="'required|numeric'"
                            name="mobile_number"
                            tabindex="3"
                            :class="{'border-red':errors.has('mobile_number')}">
                        <div v-show="errors.has('mobile_number')" class="text-red text-sm mt-2">
                            {{ errors.first('mobile_number') }}
                        </div>
                    </div>
                    <div class="w-full sm:w-1/2 mt-4 sm:mt-0">
                        <label class="font-medium">Company Name</label>
                        <input type="text" 
                            class="w-full border py-2 px-3 mt-2 rounded" 
                            tabindex="4"
                            v-model="form.user.company_name">
                    </div>
                </div>
                <button type="submit" class="invisible"></button>
            </form>
        </div>

        <div class="text-center mt-4" v-if="detailReview">
            <button class="border bg-grey-lighter p-4 w-32 text-black border-grey rounded font-medium" type="submit" @click="backToFinish()">Back</button>
        </div>

        <div class="flex flex-row justify-between mt-4" v-else>
            <button class="border bg-grey-lighter p-4 w-32 text-black border-grey rounded font-medium" type="button" @click="back()">Back</button>
            <button class="border bg-brand p-4 w-32 text-white rounded font-medium" type="submit" @click="validateAndNext()">Continue</button>
        </div>
    </div>
</template>

<script>
export default {
  props: ["value", "step", "detail-review", "steps"],

  data() {
    return {
      form: _.cloneDeep(this.value)
    };
  },

  mounted() {
    let next = _.toNumber(this.step) + 1;
    this.next = next;

    let prev = _.toNumber(this.step) - 1;
    this.prev = prev;
  },

  methods: {
    validateAndNext() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit("go-to", {
            next_step: this.next
          });
        }
      });
    },
    back() {
      this.$emit("go-to", {
        next_step: this.prev,
        next_sub_step: 2
      });
    },
    backToFinish() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit("go-to", {
            next_step: _.findLastKey(this.steps)
          });
        }
      });
    }
  },

  watch: {
    form: {
      deep: true,
      handler: function() {
        this.$emit("input", this.form);
      }
    }
  }
};
</script>

<style>
</style>
